export enum FIELD_TYPES {
    LOOKUP = 'lookup_relationship',
    MASTER = 'master_detail_relationship',
    TEXT = 'text',
    LONGTEXT = 'textarea',
    NUMBER = 'number',
    DATE = 'date',
    TIME = 'time',
    DATETIME = 'datetime',
    CHECKBOX = 'checkbox',
    EMAIL = 'email',
    RADIO = 'radio',
    BOOLEAN = 'boolean',
    PHONE = 'phone',
    PICKLIST = 'picklist',
    MULTIPICKLIST = 'multiPicklist',
    URL = 'url',
    GEOLOCATION = 'geolocation',
    FORMULA = 'formula',
    ROLLUP = 'rollup_summary',
    CURRENCY = 'currency',
    COMPOSITE = 'composite',
    SELECT = 'select',
    MULTICHECKBOX = 'multiCheckbox',
    IMAGE = 'image',
    FOLDER = 'folder',
    SINGLE_IMAGE = 'SingleImage',
    DOCUMENT_EDITOR = 'documentEditor',
    GENDER_PICKLIST = 'genderPicklist',
    ROLE_PICKLIST = 'rolePicklist',
    COUNTRY_PICKLIST = 'countryPicklist',
    PASSWORD = 'password',
}

export enum BACKEND_FIELD_TYPES {
    IMAGE = 'image',
    TEXT = 'varchar',
    BOOLEAN = 'boolean',
    LONGTEXT = 'text',
    DECIMAL = 'decimal',
    NUMBER = 'int',
    DATETIME = 'datetime',
    MULTISELECT = 'multiSelect',
    SELECT = 'select'
}